import React from 'react'

const faqs = [
    { q: "What is Hustle Connects?", a: "Hustle Connects is a platform that links people who need services (requesters) with people who can provide them (providers), making transactions simple, safe, and rewarding." },
    { q: "How do I publish a request?", a: "Log in, visit the category page, select service type and field and fill form with the service details and submit." },
    { q: "How do providers get approved?", a: "Once you publish a request, qualified providers apply. You review their profiles and approve the one that best fits your needs." },
    { q: "How do payments work?", a: "Requesters pay upfront through the platform. Funds are held securely until the provider completes the service, then released to them." },
    { q: "Can I cancel a request?", a: "Yes, but only before approving a provider or before being approved. After approval, cancellations are not allowed except in special cases." },
    { q: "How do I earn Hustle Points (HP)?", a: "You earn HP by engaging in transactions, completing services, and staying active on the platform." },
    { q: "Why do I need to verify my account?", a: "Verification builds trust and ensures safe transactions for both requesters and providers." },
    { q: "How do service providers get paid?", a: "Payments are sent directly to providers after successful completion of a service, minus platform charges." },
    { q: "What happens if there’s a dispute?", a: "Hustle Connects provides a dispute resolution system where our team mediates fairly between requester and provider." },
    // { q: "Is there a fee for using Hustle Connects?", a: "Yes, a small service fee applies to each transaction. This keeps the platform running and secure." },
    { q: "How do Requesters pay?", a: "Requesters pay through mobile money, bank cards, or other approved methods on Hustle Connects." },
    { q: "Is payment safe?", a: "Yes. Hustle Connects holds the money securely until the Provider completes the service." },
    // { q: "When do Providers get paid?", a: "Providers are paid after the Requester confirms the service is completed." },
    { q: "How fast will Providers receive money?", a: "Payments are usually instant." },
    // { q: "What fees are involved?", a: "A small service fee is applied to both Requesters and Providers. All charges are shown before payment." },
    { q: "What if a Requester cancels?", a: "If canceled before approval, no fees apply." }
]

function FAQs() {
    return (
        <section id="faqs">
            <div className="container">
                <div className="row mb-4 mt-1">
                    <div className="col-md-12 h-100 text-center text-md-start p-0 p-md-5 pb-3">
                        <h2 className="mt-3">Frequently Asked Questions</h2>
                        <p className="mb-0" style={{fontSize: 14}}>Find quick answers to the most common questions about HustleConnect. Whether you{"'"}re a service provider or a client, this section helps you understand how our platform works.</p>
                        <div className="accordion mt-3" id="faqAccordion">
                            {faqs.map((item, index) => (
                                <div className="accordion-item mb-2" key={index}>
                                    <h2 className="accordion-header" id={`heading-${index}`}>
                                        <button className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                        type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${index}`}
                                        aria-expanded={index === 0 ? "true" : "false"} aria-controls={`collapse-${index}`}>
                                            {item.q}
                                        </button>
                                    </h2>
                                    <div id={`collapse-${index}`}
                                        className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                        aria-labelledby={`heading-${index}`} data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">{item.a}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FAQs
